<template>
 <div v-loading="velocityEthLoading">

      <!-- 公式 -->
      <el-row type="flex" justify="center">
      <section class="formulas">
          <div>Velocity =</div>
          <div>
            <span>1</span>
            <span> NVT Ratio </span>
          </div>
          &nbsp;          
          =
          <div>
            <span>Transaction Volume <span style="color:rgba(0,0,0,0.4)">[USD]</span></span>
            <span>Market Cap <span style="color:rgba(0,0,0,0.4);border:none">[USD]</span></span>
          </div>
      </section>
   </el-row>
   <!-- 对数线性显示切换 -->

    <!-- <el-row class="switch">
      <el-col>
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">      
        <div
          id="velocityEthBox"
         style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../velocityEth/index"
export default {
  mixins:[IndexJs]
}
</script>

<style lang="scss">
  .formulas{
    
    div:nth-of-type(3){
      // outline: 1px solid red;
      display: flex;
      flex-direction: column;
      margin-left: 5px;
      text-align: center;
      span:nth-of-type(1){
        border-bottom: 1px solid rgba(0,0,0,1);
      }
    }
  
  }

</style>